import styled from 'styled-components';
import { Row } from 'antd';

export const TaskItem = styled(Row)`
	border-radius: 6px;
	background-color: #ffffff;
	border: 2px solid #e6e6e6;
	.ant-col {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 8px 12px;
		&:first-child {
			justify-content: flex-start;
		}
		&:nth-child(2) {
			border-right: 1px solid #e6e6e6;
			border-left: 1px solid #e6e6e6;
		}
	}
`;

export const DeleteButton = styled.button`
	width: 100%;
	border: none;
	display: flex;
	font-size: 1.5rem;
	align-items: center;
	height: max-content;
	justify-content: center;
	background: transparent;
	&:hover {
		cursor: pointer;
	}
`;
